const routeNewsDetail = (id = ':id') => `/newsDetail/${id}`;

export default routeNewsDetail;
